import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodYESOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeDeliveryMethodYESOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        const self = this,
            { doesNotMatchedPointCriteria } = self.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodYESOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{width: '58em'}}>
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    {doesNotMatchedPointCriteria.map((item, index) => {
                        return (
                            <p key={index}>Please change your selections for Delivery "{item.deliveryNumber}". The items selected do not meet the points criteria for the shipping method selected.</p>
                        );
                    })}
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ChangeDeliveryMethodYESOverlayDialog = connect(mapStateToProps)(ChangeDeliveryMethodYESOverlayDialog);
export default ChangeDeliveryMethodYESOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/multipleDeliveryPointCriteriaNotMatchedOverlayDialog.js